import AffiliateShoppingLayout from "@app/layouts/AffiliateShopping/AffiliateShoppingLayout";
import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import { AffiliateShoppingData } from "@app/types/ServerCustomContext";
import AdSettings from "@app/utils/AdSettings";
import MetaData from "@components/Modules/MetaData";
import { mapStaticContentDataToMetaData } from "@components/Modules/MetaData/mappers";
import PubBaseLayout from "@pub/BaseLayout";
import { configAffiliateShopping } from "@pub/config";
import {
  CustomContext,
  ResponseType,
  TRouteWithRedirect,
  useRouteContext,
} from "@sphtech/web2-core/ssr";
import { useLocation } from "react-router";

export default function AffiliateShopping() {
  const routeContext: CustomContext<
    TRouteWithRedirect<AffiliateShoppingData, string>
  > = useRouteContext();

  // Context from server.ts
  const { context: response } = routeContext;
  const location = useLocation();

  if (response.type !== ResponseType.SUCCESS) {
    return <ErrorLayout response={response} />;
  }

  const affiliateShoppingData = response.payload;
  const metaData = mapStaticContentDataToMetaData(affiliateShoppingData);

  return (
    <PubBaseLayout>
      <MetaData {...metaData} />
      <AdSettings
        pageType="category"
        sectionName="Affiliate Shopping"
        adUnits="lb1,lb2,imu1,imu2,catfish,prestitial"
        pageTitle="Affiliate Shopping"
        currentLocation={location}
      />
      <AffiliateShoppingLayout
        data={{
          heading: affiliateShoppingData.headline,
          headingZH: affiliateShoppingData.headlineZH,
          showVerticalLine: configAffiliateShopping.withDivider,
          blocks: affiliateShoppingData.blocks,
          uniqSectionName: affiliateShoppingData.uniqSectionName,
          standFirst: affiliateShoppingData.standfirst,
          displaySetting: affiliateShoppingData.displaySetting,
        }}
      />
    </PubBaseLayout>
  );
}
